import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import LoginPage from "ui/pages/LoginPage";
import CMRAuthRoute from "ui/components/CMRAuthRoute";
import ModelPage from "ui/pages/ModelPage";
import NewOrLoadPage from "ui/pages/neworload/NewOrLoadPage";
import NewSetupPage from "ui/pages/newsetup/NewSetupPage";
import CategoryPage from "ui/pages/category/CategoryPage";
import RoutesName from "./routesName";
import PresetPage from "ui/pages/preset/PresetPage";
import ImportPage from "ui/pages/import/ImportPage";

/**
 * @constructor
 */
const CMRRoutes: React.FC = () => {
    return (
        <Switch>
            <CMRAuthRoute path={RoutesName.modelPage} exact={true} component={ModelPage} />
            <CMRAuthRoute path={RoutesName.newOrLoad} exact={true} component={NewOrLoadPage} />
            <CMRAuthRoute path={RoutesName.newSetup} exact={true} component={NewSetupPage} />
            <CMRAuthRoute path={RoutesName.preset} exact={true} component={PresetPage} />
            <CMRAuthRoute path={RoutesName.category} exact={true} component={CategoryPage} />
            <CMRAuthRoute path="/" exact component={PresetPage} />
            <CMRAuthRoute path={RoutesName.import} exact={true} component={ImportPage} />
            <Route path={RoutesName.login} exact component={LoginPage} />
            <Redirect to={RoutesName.home} />
        </Switch>
    );
};

export default CMRRoutes;
